module.exports = __webpack_public_path__ + "static/media/TEL.6c2f8737.svg";